<template>
  <ul
    class="gallery"
    :class="[
      'gallery--' + width
    ]">
    <li
      v-for="(item, key) in images"
      class="item"
      :key="`item${key}`"
      :class="[
        'item--' + columns,
        {
          'item--highlight': item.highlight
        }
      ]">
      <div
        class="item__image"
        :class="{
          'item__image--landscape': item.image.width > item.image.height,
          'item__image--portrait': item.image.height >= item.image.width,
          'item__image--caption': item.caption !== '',
        }">
        <img
          :src="item.image.url"
          @click="highlight(images, key)" />
        <p
          v-if="width === 'floorplan'"
          class="note">
          <span
            v-if="note !== ''"
            v-html="note"></span>
          <span v-else>
            Click to enlarge
          </span>
        </p>
      </div>
      <p
        v-if="item.caption !== ''"
        class="note"
        v-html="item.caption"></p>
    </li>
  </ul>
</template>

<script>
import ImageBlock from '@/components/base/ImageBlock'

export default {
  name: 'LinkedGallery',
  props: {
    images: {
      type: Array,
      default: null
    },
    width: {
      type: String,
      default: 'inline'
    },
    columns: {
      type: String,
      default: '33'
    },
    note: {
      type: String,
      default: null
    }
  },
  methods: {
    highlight(items, key) {
      this.$root.$emit('galleryHighlight', items, key)
    }
  }
}
</script>

<style lang="scss" scoped>
.gallery {
  display:flex;
  flex-wrap:wrap;
  align-items:flex-start;

  .item {
    display:flex;
    flex-direction: column;

    &__image {
      &--caption {
        margin-bottom: 4px !important;
      }

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    &--33 {
      width:calc(33% - 0.6rem);
      margin:0 $padding #{$padding * 1} 0;

      .item__image {
        &--portrait {
          height: calc((33vw - #{$padding * 2} - #{$padding * 2 / 3}) * 1.25);
          max-height: calc((#{$content-width / 3} - #{$padding * 2} - #{$padding * 2 / 3}) * 1.25);
        }

        &--landscape {
          height: calc((33vw - #{$padding * 2} - #{$padding * 2 / 3}) * 0.667);
          max-height: calc((#{$content-width / 3} - #{$padding * 2} - #{$padding * 2 / 3}) * 0.667);
        }
      }

      &:nth-child(3n + 3) {
        margin-right: 0px;
      }
    }

    &--25 {
      width:calc(25% - #{$padding * 3 / 4});
      margin:0 $padding #{$padding * 1} 0;

      .item__image {
        &--portrait {
          height: calc((25vw - #{$padding * 2} - #{$padding * 3 / 4}) * 1.25);
          max-height: calc((#{$content-width / 4} - #{$padding * 2} - #{$padding * 3 / 4}) * 1.25);
        }

        &--landscape {
          height: calc((25vw - #{$padding * 2} - #{$padding * 3 / 4}) * 0.667);
          max-height: calc((#{$content-width / 4} - #{$padding * 2} - #{$padding * 3 / 4}) * 0.667);
        }
      }

      &:nth-child(4n + 4) {
        margin-right: 0px;
      }
    }

    &--50 {
      width:calc(50% - #{$padding});
      margin:0 $padding #{$padding * 1} 0;

      .item__image {
        &--portrait {
          height: calc((50vw - #{$page-padding * 2} - #{$padding / 2}) * 1.25);
          max-height: calc((#{$content-width / 2} - #{$page-padding * 2} - #{$padding / 2}) * 1.25);
        }

        &--landscape {
          height: calc((50vw - #{$page-padding * 2} - #{$padding / 2}) * 0.667);
          max-height: calc((#{$content-width / 2} - #{$page-padding * 2} - #{$padding / 2}) * 0.667);
        }
      }
    }

    &--100 {
      width:calc(100% - #{$padding});
    }

    &--highlight {
      cursor: pointer;
    }

    img {
      float: left;
    }

    .note {
      min-height: 2.25rem;
    }
  }

  &--floorplan {
    .item {
      &__image {
        position: relative;
        overflow: hidden;
        &:hover {
          img {
            filter: blur(5px)
          }
          .note {
            opacity: 1;
          }
        }
        .note {
          opacity: 0;
          // content: 'Typical floorplan (click to enlarge)';
          position: absolute;
          font-size: $heading;
          top: 50%;
          left: 50%;
          width: 60%;
          text-align: center;
          transform: translate(-50%, -50%);
          z-index: 1;
          pointer-events: none;
          transition: opacity 150ms ease-in-out;
        }

        img {
          filter: blur(0px);
          transition: filter 200ms ease-in-out;
        }
      }
    }
  }

  @include mobile {
    .item {
      width:100% !important;
      margin:0 0 $padding 0 !important;

      &__image {
        width: 100%;
        height: auto !important;
        img {
          margin-bottom: 4px !important;
          object-fit: contain;
          object-position: 0% 0%;
        }
      }
    }
  }
}
</style>
